module.exports = __webpack_public_path__ + "img/MBT_R_WD.4017bb74.png";